import React from "react";
import "./App.css";
import CyberpunkPortfolio from "./components/CyberpunkPortfolio";

function App() {
  return (
    <div className="App">
      <CyberpunkPortfolio />
    </div>
  );
}

export default App;